const defaultOoptoutMessage = '\nopt-out STOP'
const defaultMaxMessages = 4

const TRACKED_LINK_SAMPLE = "TapTh.is/zbrhlPN6"
const TRACKING_LINKS_PREDEFINED = [
    "[tracked-link]",
    "[review-location-link]"
]

function removeAll(string, search) {
    return string.split(search).join(TRACKED_LINK_SAMPLE);
}

module.exports = class SmsContentHelper {
    constructor(optoutMessage, maxMessages, trackingLinks) {
        this.optoutMessage = optoutMessage ? optoutMessage : defaultOoptoutMessage
        this.maxMessages = maxMessages ? maxMessages : defaultMaxMessages
        this.asciiRegex = /^[\x20-\x7F,\n]+$/
        this.asciiMessageLength = 160
        this.utfMessageLength = 70
        this.trackingLinks = trackingLinks || TRACKING_LINKS_PREDEFINED
    }

    getSingleMessageLength(content) {
        return !content || this.asciiRegex.test(content)
            ? this.asciiMessageLength
            : this.utfMessageLength
    }

    getMaxMessageLength(content) {
        return this.maxMessages * this.getSingleMessageLength(content) - this.optoutMessage.length
    }

    getNumberOfMessages(content, contentContainsOptOutMessage = false) {
        if (!content) {
            return 0
        }

        this.trackingLinks.forEach(x => content = removeAll(content, x))

        const totalMessageLength = (content.length + (contentContainsOptOutMessage ? 0 : this.optoutMessage.length))
        const singleMessageLength = this.getSingleMessageLength(content)
        return Math.ceil(totalMessageLength / singleMessageLength)
    }
}